import './App.css'

function App() {
  return <div className="App">Cloud CDN</div>
}

export default App
